import { AbstractCommand } from "@astina/paloma-common-ui/src/services/CommandQueue";
import paloma from "@astina/paloma-common-ui/src/services/PalomaBackend";
import ValidationUtils from "@astina/paloma-common-ui/src/services/ValidationUtils";
import alerts from "@astina/paloma-common-ui/src/services/Alerts";
import translate from "@astina/paloma-common-ui/src/services/Translator";
export function updateDemandItem(draft) {
    return new UpdateDemandItem(draft)
        .enqueue();
}
export class UpdateDemandItem extends AbstractCommand {
    draft;
    constructor(draft) {
        super();
        this.draft = draft;
    }
    execute() {
        return paloma
            .execute(this.name(), this.draft)
            .then(data => {
            return data;
        })
            .catch((error) => {
            try {
                const validation = ValidationUtils.createValidation(error);
                ValidationUtils.alertAll(validation);
            }
            catch (e) {
                alerts.error(translate(`command.${this.name()}.error`));
            }
            throw error;
        });
    }
    name() {
        return "update_demand_item";
    }
    requiresPermission() {
        return 'ROLE_PERM_PORTAL_DEMAND_MANAGE';
    }
}
